/**
 * Make sure this file is mapped with correct values corresponding to those in
 * Wombit.Plugin.Widgets.ContentBlocks/Plugin.cs:GetWidgetZonesAsync()
 */
const widgetZones = Object.freeze({
    homepageTop: 'home_page_top',
    homepageBeforeProducts: 'home_page_before_products',
    homepageBeforeCategories: 'home_page_before_categories',
    homepageBeforeBestSellers: 'home_page_before_best_sellers',
    homepageBeforeNews: 'home_page_before_news',
    homepageBeforePoll: 'home_page_before_poll',
    homepageBottom: 'home_page_bottom',

    categoryDetailsTop: 'categorydetails_top',
    categoryDetailsAfterBreadcrumb: 'categorydetails_after_breadcrumb',
    categoryDetailsBeforeFilters: 'categorydetails_before_filters',
    categoryDetailsBeforeProductList: 'categorydetails_before_product_list',
    categoryDetailsBottom: 'categorydetails_bottom',

    productDetailsTop: 'productdetails_top',
    productDetailsEssentialTop: 'productdetails_essential_top',
    productDetailsEssentialBottom: 'productdetails_essential_bottom',
    productDetailsBottom: 'productdetails_bottom',
})

export { widgetZones }
export default widgetZones;